// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wishlist-rank-page .margin-top-40 {
  margin-top: 40px; }

.wishlist-rank-page p {
  color: #6D6E71; }

.wishlist-rank-page .wishlist-grid-container {
  display: grid;
  grid-template-columns: 8% auto;
  grid-template-rows: auto;
  padding: 20px;
  background-color: #dcdcdc; }
  .wishlist-rank-page .wishlist-grid-container .wishlist-grid-header {
    font-weight: bolder; }

.wishlist-rank-page .wishlistDraggable {
  width: 100%;
  color: #6D6E71;
  border-bottom: 2px solid #dcdcdc;
  padding: 20px;
  display: grid;
  grid-template-columns: 8% 68% 14% 10%; }
  .wishlist-rank-page .wishlistDraggable a {
    color: #6D6E71; }

.wishlist-rank-page .action-button {
  background-color: transparent;
  border: 2px solid #4330ff;
  color: #4330ff;
  border-radius: 5px;
  padding: 5px; }

.wishlist-rank-page .inaction-button {
  background-color: transparent;
  border: 2px solid #6D6E71;
  color: #6D6E71;
  border-radius: 5px;
  padding: 5px; }

.wishlist-rank-page .rank {
  margin-left: 15px;
  font-size: 20px;
  top: 10px; }

.wishlist-rank-page .informational {
  color: rgba(109, 110, 113, 0.5);
  margin-top: 10px; }

.wishlist-rank-page .user-detail {
  margin-top: 8px; }
  .wishlist-rank-page .user-detail .user-detail-link {
    color: #4330ff;
    text-decoration: underline;
    font-weight: 600;
    cursor: pointer; }

@media only screen and (max-width: 585px) {
  .wishlist-rank-page .wishlistDraggable {
    display: block;
    text-align: center; } }

@media only screen and (max-width: 992px) {
  .wishlist-rank-page .wishlistDraggable {
    grid-template-columns: 10% 55% 15% 20%; }
  .wishlist-rank-page .informational {
    width: 100%;
    display: block; } }
`, "",{"version":3,"sources":["webpack://./src/components/VirtualPortal/WishlistRank/wishlist-rank.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB,EAAE;;AAEpB;EACE,cAAc,EAAE;;AAElB;EACE,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;EACxB,aAAa;EACb,yBAAyB,EAAE;EAC3B;IACE,mBAAmB,EAAE;;AAEzB;EACE,WAAW;EACX,cAAc;EACd,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,qCAAqC,EAAE;EACvC;IACE,cAAc,EAAE;;AAEpB;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY,EAAE;;AAEhB;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY,EAAE;;AAEhB;EACE,iBAAiB;EACjB,eAAe;EACf,SAAS,EAAE;;AAEb;EACE,+BAA+B;EAC/B,gBAAgB,EAAE;;AAEpB;EACE,eAAe,EAAE;EACjB;IACE,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe,EAAE;;AAErB;EACE;IACE,cAAc;IACd,kBAAkB,EAAE,EAAE;;AAE1B;EACE;IACE,sCAAsC,EAAE;EAC1C;IACE,WAAW;IACX,cAAc,EAAE,EAAE","sourcesContent":[".wishlist-rank-page .margin-top-40 {\n  margin-top: 40px; }\n\n.wishlist-rank-page p {\n  color: #6D6E71; }\n\n.wishlist-rank-page .wishlist-grid-container {\n  display: grid;\n  grid-template-columns: 8% auto;\n  grid-template-rows: auto;\n  padding: 20px;\n  background-color: #dcdcdc; }\n  .wishlist-rank-page .wishlist-grid-container .wishlist-grid-header {\n    font-weight: bolder; }\n\n.wishlist-rank-page .wishlistDraggable {\n  width: 100%;\n  color: #6D6E71;\n  border-bottom: 2px solid #dcdcdc;\n  padding: 20px;\n  display: grid;\n  grid-template-columns: 8% 68% 14% 10%; }\n  .wishlist-rank-page .wishlistDraggable a {\n    color: #6D6E71; }\n\n.wishlist-rank-page .action-button {\n  background-color: transparent;\n  border: 2px solid #4330ff;\n  color: #4330ff;\n  border-radius: 5px;\n  padding: 5px; }\n\n.wishlist-rank-page .inaction-button {\n  background-color: transparent;\n  border: 2px solid #6D6E71;\n  color: #6D6E71;\n  border-radius: 5px;\n  padding: 5px; }\n\n.wishlist-rank-page .rank {\n  margin-left: 15px;\n  font-size: 20px;\n  top: 10px; }\n\n.wishlist-rank-page .informational {\n  color: rgba(109, 110, 113, 0.5);\n  margin-top: 10px; }\n\n.wishlist-rank-page .user-detail {\n  margin-top: 8px; }\n  .wishlist-rank-page .user-detail .user-detail-link {\n    color: #4330ff;\n    text-decoration: underline;\n    font-weight: 600;\n    cursor: pointer; }\n\n@media only screen and (max-width: 585px) {\n  .wishlist-rank-page .wishlistDraggable {\n    display: block;\n    text-align: center; } }\n\n@media only screen and (max-width: 992px) {\n  .wishlist-rank-page .wishlistDraggable {\n    grid-template-columns: 10% 55% 15% 20%; }\n  .wishlist-rank-page .informational {\n    width: 100%;\n    display: block; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
